import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Tooltip as MUITooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { withTheme } from 'styled-components'

const useStyles = () =>
  makeStyles(() => ({
    tooltip: {
      fontFamily: 'Roboto',
      fontSize: '14px',
      padding: '16px',
      backgroundColor: '#1C1C1C',
      boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.2)',
    },
    arrow: {
      color: '#1C1C1C',
    },
  }))()

const Tooltip = ({ theme, title, children }) => {
  const classes = useStyles(theme)

  return (
    <MUITooltip title={title} classes={{ tooltip: classes.tooltip, arrow: classes.arrow }} arrow>
      {children}
    </MUITooltip>
  )
}

export default memo(withTheme(Tooltip))

Tooltip.propTypes = {
  /**
   * Theme object used for style customization.
   */
  theme: PropTypes.object,
  /**
   * Tooltip content
   */
  title: PropTypes.string,
  children: PropTypes.element,
}

Tooltip.defaultProps = {
  theme: {},
  title: '',
}
